import React from 'react';
import './LoadMoreButton.scss';
import arrowDownIcon from 'assets/images/icons/users/arrow-down.svg';

export type LoadMoreButtonProps = {
    label: string;
    onClick: () => void;
    disabled?: boolean;
};

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ label, onClick, disabled = false }) => {
    return (
        <button
            type="button"
            className="load-more-button"
            onClick={onClick}
            disabled={disabled}
        >
            <img src={arrowDownIcon} alt="" aria-hidden="true" />
            <span>{label}</span>
        </button>
    );
};
